import React from "react";
import { useStores } from "../../../hooks/useStores";
import { observer } from "mobx-react";
import { MainObjective } from "../../../components/MainObjective";
import { ObjectiveList } from "../../../components/ObjectiveList";
import { Box, Flex } from "@chakra-ui/react";

export const TabObjective: React.FC = observer(() => {
  const { clientsStore } = useStores();

  if (!clientsStore.customerData?.id) {
    return <div></div>;
  }

  return (
    <Flex justifyContent={"space-evenly"}>
      <Box w={"30%"} p="4">
        <MainObjective userId={clientsStore.customerData?.id} />
      </Box>
      <Box w={"30%"} p="4">
        <ObjectiveList userId={clientsStore.customerData?.id} />
      </Box>
    </Flex>
  );
});
